module.exports = __webpack_public_path__ + "img/tab01.25673cba.png";